var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useThemeValue } from '../../state/theme';
import { LinkBase } from '../LinkBase';
export const Link = (props) => {
    const { className, children } = props, otherProps = __rest(props, ["className", "children"]);
    const linkColorClass = useThemeValue('link', 'text-teal-700 hover:text-blue-600 focus:text-blue-600');
    return (_jsx(LinkBase, Object.assign({ className: clsx('focus:outline-none', linkColorClass, className) }, otherProps, { children: children }), void 0));
};
//# sourceMappingURL=Link.js.map